import {
    MSC_FETCH_PLUGINS_REQUEST,
    MSC_FETCH_PLUGINS_RESULT,
    MSC_FETCH_PLUGIN_REQUEST,
    MSC_GET_ALL_PLUGINS,
    MSC_GET_PLUGIN,
    MSC_GET_CURRENT_PAGE,
    // MSC_GET_PLUGINS_FOR_PRACTICE,
    MSC_PLUGIN_ERROR,
    MSC_SET_FILTER,
    MSC_SET_PIMS_FILTER,
    MSC_SET_CURRENT_PAGE,
    MSC_SET_TOTAL_PAGES,
    MSC_SET_PLUGIN_ID,
    MSC_SET_INCLUDE_INACTIVE_PLUGINS,
    MSC_SEARCHING_FOR_PLUGINS,
    MSC_SET_EDITMODAL_ACTIVE_PLUGIN,
    MSC_SET_EDITMODAL_ACTIVE_PLUGIN_ID,
    MSC_SET_EDITMODAL_PLUGIN_STATUS,
    MSC_SET_PLUGIN_ISINACTIVE,
    MSC_SET_SELECTED_PLUGIN_DEFAULTVERSION,
    //Plugin Dependencies
    MSC_SET_EDITMODAL_PLUGIN_DEPENDENCIES,
    MSC_REMOVE_EDITMODAL_PLUGIN_DEPENDENCY,
    MSC_RESET_EDITMODAL_PLUGIN_DEPENDENCIES,
    MSC_SOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES,
    MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES,
    MSC_SET_EDITMODAL_PIMS_DEPENDENCIES,
    MSC_REMOVE_EDITMODAL_PIMS_DEPENDENCY,
    MSC_RESET_EDITMODAL_PIMS_DEPENDENCIES,
    MSC_SOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES,
    MSC_RESETSOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES,
    MSC_SET_EDITMODAL_PLUGIN_VERSION,
    MSC_UPDATE_EDITMODAL_PLUGIN_VERSION,
    MSC_REMOVE_EDITMODAL_PLUGIN_VERSION,
    MSC_RESET_EDITMODAL_PLUGIN_VERSION,
    MSC_SOURCESTATE_EDITMODAL_PLUGIN_VERSION,
    MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_VERSION,
} from '../ActionTypes';

const initialState = {
    //searching parameters
    plugins: [],
    plugin: {},
    pluginInfo: {},
    pluginCurrentPage: 1,
    pluginTotalPages: 1,
    isAllPluginsRunning: true,
    isPluginRunning: true,
    isPluginInactive: false,
    includeInactivePlugins: false,
    pluginError: '',
    pluginFilter: '',
    pimsFilter: '',
    currentPluginId: '',
    searchingForPlugins: false,
    pluginDependencies: [],
    pimsDependencies: [],
    pluginVersions: [],
    selectedDefaultVersion: '',
    sourcepluginVersions: [],
    sourcepluginDependencies: [],
    sourcepimsDependencies: [],
    editCurrentPlugin: {},
    editCurrentPluginId: '',
    editModalPluginStatus: {
        detailPlugin: false,
        addNewPlugin: false,
        addDependencies: false,
        editingPlugin: false,
        editingVersions: false,
    },
};

const missionControlReduction = (state = initialState, action) => {
    switch (action.type) {
        case MSC_FETCH_PLUGINS_REQUEST:
            return {
                ...state,
                isAllPluginsRunning: true,
            };
        case MSC_FETCH_PLUGINS_RESULT:
            let plugins = action.payload.plugins || [];
            return {
                ...state,
                isAllPluginsRunning: false,
                plugins: plugins,
                pluginTotalPages: action.payload.pluginTotalPages,
                //practiceLink: action.payload.practiceTab,
            };
        case MSC_FETCH_PLUGIN_REQUEST:
            return {
                ...state,
                isPluginRunning: true,
            };
        case MSC_GET_ALL_PLUGINS:
            return {
                ...state,
                allPlugins: action.payload,
                isAllPluginsRunning: false,
            };
        case MSC_GET_PLUGIN:
            return {
                ...state,
                plugin: action.payload,
                isPluginRunning: false,
                pluginError: '',
            };
        case MSC_PLUGIN_ERROR:
            return {
                ...state,
                isPluginRunning: false,
                pluginError: action.payload,
            };

        case MSC_GET_CURRENT_PAGE:
            return {
                ...state,
                pluginCurrentPage: action.payload,
            };
        case MSC_SET_CURRENT_PAGE:
            return {
                ...state,
                pluginCurrentPage: action.payload,
            };
        case MSC_SET_FILTER:
            return {
                ...state,
                pluginFilter: action.payload,
            };
        case MSC_SET_PIMS_FILTER:
            return {
                ...state,
                pimsFilter: action.payload,
            };
        case MSC_SET_TOTAL_PAGES:
            return {
                ...state,
                pluginTotalPages: action.payload,
            };
        case MSC_SET_INCLUDE_INACTIVE_PLUGINS:
            return {
                ...state,
                includeInactivePlugins: action.payload,
            };
        case MSC_SEARCHING_FOR_PLUGINS:
            return {
                ...state,
                searchingForPlugins: action.payload,
            };
        case MSC_SET_PLUGIN_ID:
            return {
                ...state,
                currentPluginId: action.payload,
            };
        case MSC_SET_PLUGIN_ISINACTIVE:
            return {
                ...state,
                isPluginInactive: action.payload,
            };
        //PLUGIN DEPENDENCIES
        case MSC_SET_EDITMODAL_PLUGIN_DEPENDENCIES:
            return {
                ...state,
                pluginDependencies: [
                    ...state.pluginDependencies,
                    action.payload,
                ],
            };
        case MSC_REMOVE_EDITMODAL_PLUGIN_DEPENDENCY:
            return {
                ...state,
                pluginDependencies: state.pluginDependencies.filter(
                    (item) => item.plugins !== action.payload
                ),
            };
        case MSC_RESET_EDITMODAL_PLUGIN_DEPENDENCIES:
            return {
                ...state,
                pluginDependencies: action.payload,
            };
        case MSC_SOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES:
            return {
                ...state,
                sourcepluginDependencies: [...state.sourcepluginDependencies, action.payload],
            };
        case MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES:
            return {
                ...state,
                sourcepluginDependencies: action.payload,
            };
        case MSC_SET_EDITMODAL_PIMS_DEPENDENCIES:
            return {
                ...state,
                pimsDependencies: [...state.pimsDependencies, action.payload],
            };
        case MSC_REMOVE_EDITMODAL_PIMS_DEPENDENCY:
            let pimsData = action.payload;
            let newpimsDependencies = state.pimsDependencies;

            if (pimsData?.pims.trim() !== '' && pimsData?.pimsVersion.trim() !== '') 
            {
                newpimsDependencies = state.pimsDependencies.filter(
                    (item) =>
                        item.pims !== pimsData?.pims ||
                        item.pimsVersion !== pimsData?.pimsVersion
                );
            } else if (pimsData?.pims.trim() !== '') 
            {
                newpimsDependencies = state.pimsDependencies.filter(
                    (item) => item.pims !== pimsData?.pims
                );
            }

            return {
                ...state,
                pimsDependencies: newpimsDependencies,
            };
        case MSC_RESET_EDITMODAL_PIMS_DEPENDENCIES:
            return {
                ...state,
                pimsDependencies: action.payload,
            };
        case MSC_SOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES:
            return {
                ...state,
                sourcepimsDependencies: [...state.sourcepimsDependencies, action.payload],
            };
        case MSC_RESETSOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES:
            return {
                ...state,
                sourcepimsDependencies: action.payload,
            };
        case MSC_SET_EDITMODAL_PLUGIN_VERSION:
            return {
                ...state,
                pluginVersions: [...state.pluginVersions, action.payload],
            };
        case MSC_UPDATE_EDITMODAL_PLUGIN_VERSION:
            const pluginsUpdated = state.pluginVersions.map((plugin) => {
                if (plugin.pluginId === action.payload.pluginId && plugin.version === action.payload.version) 
                {
                    return { ...plugin, ...action.payload };
                }
                return plugin;
            });

            return {
                ...state,
                pluginVersions: pluginsUpdated
            }
        case MSC_REMOVE_EDITMODAL_PLUGIN_VERSION:
            let versionData = action.payload;
            return {
                ...state,
                pluginVersions: state.pluginVersions.filter(
                    (item) =>
                        item.pluginId !== versionData?.pluginId ||
                        item.version !== versionData?.version
                ),
            };
        case MSC_RESET_EDITMODAL_PLUGIN_VERSION:
            return {
                ...state,
                pluginVersions: action.payload,
            };
        case MSC_SOURCESTATE_EDITMODAL_PLUGIN_VERSION:
            return {
                ...state,
                sourcepluginVersions: [...state.sourcepluginDependencies, action.payload],
            };
        case MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_VERSION:
            return {
                ...state,
                sourcepluginVersions: action.payload,
            };
        case MSC_SET_EDITMODAL_ACTIVE_PLUGIN:
            return {
                ...state,
                editCurrentPlugin: action.payload,
            };
        case MSC_SET_EDITMODAL_ACTIVE_PLUGIN_ID:
            return {
                ...state,
                editCurrentPluginId: action.payload,
            };
        case MSC_SET_EDITMODAL_PLUGIN_STATUS:
            return {
                ...state,
                editModalPluginStatus: action.payload,
            };
        case MSC_SET_SELECTED_PLUGIN_DEFAULTVERSION:
            return {
                ...state,
                selectedDefaultVersion: action.payload,
            };
        default:
            return state;
    }
};

export default missionControlReduction;
